import { Module } from "vuex";
import { db } from '../db'
import { firestoreAction } from 'vuexfire'

import { RootState } from '..';


export interface ProfileState {
  profile: {} | null;
  profilePublic: {
    points?: number;
  } | null;
}

const AuthModule: Module<ProfileState, RootState> = {
  state: {
    profile: null,
    profilePublic: null
  },
  actions: {
    bindProfilePublic: firestoreAction(async ({ bindFirestoreRef, rootGetters }) => {
      await rootGetters.authInit
      const id = rootGetters.user.uid
      return bindFirestoreRef('profilePublic', db.collection('profilesPublic').doc(id), { reset: false })
    }),
    bindProfile: firestoreAction(async ({ bindFirestoreRef, rootGetters, getters }) => {
      if(getters.hasProfile) {
        return //already bound
      }

      await rootGetters.authInit
      const id = rootGetters.user.uid
      return bindFirestoreRef('profile', db.collection('profiles').doc(id), {reset: false})
    }),
    async persistProfile({rootGetters}, profile) {
      await rootGetters.authInit
      const id = rootGetters.user.uid
      if (profile.country != 'CH' && profile.country != 'IT') {
        profile.residence = {}
      }
      await db.collection('profiles').doc(id).set(profile, {merge: true})
    },
    async persistProfilePublic({rootGetters}, publicProfile) {
      await rootGetters.authInit
      const id = rootGetters.user.uid
      await db.collection('profilesPublic').doc(id).set(publicProfile, {merge: true})
    },
  },
  getters: {
    hasProfile(state) {

      return state.profile !== null
    },
    profile(state) {
      return state.profile ? state.profile : false
    },
    points(state) {
      return state.profilePublic && state.profilePublic.points ? state.profilePublic.points % 100 : 0
    },
    level(state) {
      return state.profilePublic && state.profilePublic.points ? Math.floor(state.profilePublic.points / 100) + 1 : 0
    }
  }
}

export default AuthModule
